<div class="modal">
  <div [class]="setModalBodyClasses()">
    <div class="modal__body__content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
